import { useEffect } from 'react';

import { useCanBootIntercom } from './useCanBootIntercom';
import { useGetContext } from '../../api/lendingApi/lendingApiQueries';
import { getRuntimeEnvironment } from '../../utils/getRuntimeEnvironment';

// Public app id (it appears in the widget URL and cookie names). Kept here
// rather than read from context, so the launcher works before there's a session.
const APP_IDS = {
  production: 'zmy6hal3',
  staging: 'hl34wnki',
};

const loadWidget = (appId: string) => {
  const queue: unknown[][] = [];
  const intercom = (...args: unknown[]) => {
    queue.push(args);
  };
  intercom.q = queue;
  window.Intercom = intercom;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://widget.intercom.io/widget/${appId}`;
  document.head.appendChild(script);
};

export const Intercom = () => {
  const { context } = useGetContext();
  const canBoot = useCanBootIntercom();

  const jwt = context?.user_intercom_jwt;
  const appId = APP_IDS[getRuntimeEnvironment()];

  useEffect(() => {
    if (!canBoot) return;

    if (!window.Intercom) loadWidget(appId);

    window.Intercom?.('boot', {
      app_id: appId,
      custom_launcher_selector: '.ChatSupportButton',
    });

    return () => window.Intercom?.('shutdown');
  }, [canBoot, appId]);

  useEffect(() => {
    if (canBoot && jwt) window.Intercom?.('update', { intercom_user_jwt: jwt });
  }, [canBoot, jwt]);

  return null;
};
